__turbopack_context__.v({
  "agent-grey-title": "style-module-scss-module__fB2kwa__agent-grey-title",
  "agent-info": "style-module-scss-module__fB2kwa__agent-info",
  "agent-name": "style-module-scss-module__fB2kwa__agent-name",
  "agent-title": "style-module-scss-module__fB2kwa__agent-title",
  "avatar-large": "style-module-scss-module__fB2kwa__avatar-large",
  "component": "style-module-scss-module__fB2kwa__component",
  "content-container": "style-module-scss-module__fB2kwa__content-container",
  "heading": "style-module-scss-module__fB2kwa__heading",
  "left-agent": "style-module-scss-module__fB2kwa__left-agent",
});
